import React from "react";
import Logo from "../../assets/LogoUniteBlanc.png";

const FooterSection = () => {
    return (
        <div className="bg-green-700 text-white">
            <div className="container mx-auto flex flex-row items-center justify-between text-center">
                <img src={Logo} className="h-32" alt="Logo Sainte Véronique" />
                <p className="text-lg">
                    Place Sainte-Véronique, 4000 Liège
                </p>
            </div>
        </div>
    );
};

export default FooterSection;
